import algoliasearch from "algoliasearch/lite";
import React from "react";
import { isDesktop } from "react-device-detect";
import ReactDOM from "react-dom";
import {
	Configure,
	InstantSearch,
	Pagination,
	SearchBox,
} from "react-instantsearch-dom";
import Accordion from "../components/react/Accordion";
import AccordionItem from "../components/react/AccordionItem";
import JobSalaryFilter from "./filters/JobSalaryFilter";
import JobTitleFilter from "./filters/JobTitleFilter";
import JobTypeFilter from "./filters/JobTypeFilter";
import LocationsFilter from "./filters/LocationsFilter";
import JobHits from "./JobHits";

const searchClient = algoliasearch(
	"G4XVN2T437",
	"387c330f2d74979c3e6cf6f64f57da05"
);

const App = () => (
	<InstantSearch searchClient={searchClient} indexName="jobs">
		<Configure hitsPerPage={5} />
		<header className="o-page-header o-page-header--green">
			<div className="container o-page-header__container o-page-header__container--h50">
				<div className="row d-flex justify-content-center align-items-center h-100">
					<div className="col-12 col-md-8 col-lg-6 o-page-header__content-container text-center">
						<h1 className="o-page-header__title d-inline-block">
							Job Vacancies
						</h1>
						<SearchBox className="c-job-search" />
					</div>
				</div>
			</div>
		</header>
		<div className="container py-3">
			<div className="row">
				<div className="col-12 col-lg-3 offset-lg-1">
					<Accordion id="filters">
						<AccordionItem
							id="job-location"
							heading="Locations"
							initiallyOpen={isDesktop}
						>
							<LocationsFilter attribute="job_location.name" />
						</AccordionItem>

						<AccordionItem
							id="job-title"
							heading="Job Title"
							initiallyOpen={isDesktop}
						>
							<JobTitleFilter attribute="job_titles.name" />
						</AccordionItem>

						<AccordionItem
							id="job-type"
							heading="Position Type"
							initiallyOpen={isDesktop}
						>
							<JobTypeFilter attribute="job_type.name" />
						</AccordionItem>

						<AccordionItem
							id="job-salary"
							heading="Salary"
							initiallyOpen={isDesktop}
						>
							<JobSalaryFilter attribute="salary_bracket.name" />
						</AccordionItem>
					</Accordion>
				</div>
				<div className="col-12 col-lg-7">
					<JobHits />
					<div className="d-flex justify-content-center mt-3">
						<Pagination showFirst={false} />
					</div>
				</div>
			</div>
		</div>
	</InstantSearch>
);

const mountPoint = document.querySelector(".js-mount-jobs");

if (mountPoint) {
	ReactDOM.render(<App />, mountPoint);
}
